import {css} from "@emotion/react";
import React from 'react';
import {Card} from "../../../TabsRoute/components/Card";
import {column, numberOfCallsText, row, textTotal, textTotalNumber, total} from "../../styles";
import {C800CallLogsContext} from "../800CallLogsProvider";
import {MenWithHeadphoneSvg} from "../MenWithHeadphoneSvg";


export const TotalCalls = () => {
    const {callLogs} = React.useContext(C800CallLogsContext);
    return (
        <Card padding={"0 40px"} contentCss={css({backgroundColor: "#F7FBFF"})}>
            <div css={column}>
                <div css={row}>
                    <div css={total}>
                        <p css={textTotal}> Total</p>
                    </div>
                </div>
                <div css={row}>
                    <div>
                        <MenWithHeadphoneSvg/>
                    </div>
                </div>
                <div css={row}>
                    <p css={textTotalNumber}>{callLogs.length}</p>
                </div>
                <div css={row}>
                    <p css={numberOfCallsText}>Number of Calls Year to Date </p>
                </div>
            </div>
        </Card>
    );
};